import React from "react";
import { Box, Typography, TextField, Select, MenuItem, Button, Divider } from "@mui/material";
import { PREFIX } from "../../../common/Config";

const CartSummaryEposSales = ({
    cartTotals,
    totalInvDiscPercent,
    onTotalInvDiscChange,
    totalInvDiscType = "percentage",
    onTotalInvDiscTypeChange,
    isEditMode = false,
    isTelecaller = false,
}) => {
    const isRhp =
        PREFIX === "rhp" ||
        localStorage.getItem("accessToken") === "rhp" ||
        localStorage.getItem("accessToken") === "hp";
    const boxCount = Number(cartTotals.boxCount) || 0;
    const pieceCount = Number(cartTotals.pieceCount) || 0;
    const totalBox = boxCount + pieceCount;

    const summaryRows = [
        ["Zero VAT Goods", cartTotals.zeroGoods],
        ["VAT Goods", cartTotals.stdGoods],
        ["VAT", cartTotals.vat],
    ];

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    backgroundColor: '#f5f7fa',
                    mb: 1,
                    border: '1px solid #E0E0E0',
                    borderRadius: '8px 8px 0 0'
                }}
            >
                <Box sx={{
                    flex: '0 0 35%',
                    display: 'flex',
                    alignItems: 'center',
                    p: { xs: 1, sm: 1.2 },
                    borderRight: '1px solid #E0E0E0'
                }}>
                    <Typography variant="body2" fontWeight={600} color="text.primary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>Total</Typography>
                </Box>

                <Box
                    sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                >
                    <Box sx={{
                        p: { xs: 0.75, sm: 1 },
                        borderBottom: isRhp ? "none" : "1px solid #E0E0E0",
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Typography variant="body2" fontWeight={600} color="text.primary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                            Total Box - {isRhp ? totalBox : boxCount}
                        </Typography>
                    </Box>
                    {!isRhp && (
                    <Box sx={{
                        p: { xs: 0.75, sm: 1 },
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}>
                        <Typography variant="body2" fontWeight={600} color="text.primary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
                            Total Piece - {pieceCount}
                        </Typography>
                    </Box>
                    )}
                </Box>
            </Box>

            {/* Rows */}
            <Box py={1}>
                {summaryRows.map(([label, value], index) => (
                    <Box key={index} >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: { xs: 0.75, sm: 1 }, px: { xs: 0.75, sm: 1 }, borderBottom: '1px dotted #E0E0E0' }}>
                            <Typography variant="caption" fontWeight={700} sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>
                                {label}
                            </Typography>
                            <Typography variant="caption" fontWeight={600} sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>
                                {(value || 0).toFixed(2)}
                            </Typography>
                        </Box>
                        <Divider />
                    </Box>
                ))}

                {/* Grand Total */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 1
                    }}
                >
                    <Typography fontWeight={700} fontSize={12}>Grand Total</Typography>
                    <Typography fontWeight={600} fontSize={12}>
                        {(cartTotals.grandTotal || 0).toFixed(2)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default CartSummaryEposSales;

